<template>
  <v-row>
    <v-col md="8" sm="12">
      <div class="">
        <h2 class="text--primary text-xl font-weight-medium">
          {{ $t("Kysymykset & vastaukset") }}
        </h2>
        <v-text-field ref="searchField" :label="$t('Haku')" dense class="mt-3 mb-3 bg-white" v-model="query" clearable
          outlined hide-details></v-text-field>
      </div>
      <v-expansion-panels>
        <v-expansion-panel v-for="faq in filteredFaq" :key="faq.id" active-class="selected-faq">
          <v-expansion-panel-header class="text-base">
            {{ faq.question }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="faq-answer">
              <div v-html="markdownToHtml(faq.answer)"></div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import api from "@/api/";
import { mdiPhone, mdiEmail, mdiAccountCircle } from "@mdi/js";
import { useTranslations } from "@core/libs/i18n";
import useMarkdown from "@/@core/utils/useMarkdown";

export default {
  setup() {
    const faq = ref([]);
    const filteredFaq = ref([]);
    const query = ref("");
    const queryTimeOut = null;

    const { t } = useTranslations();
    const { markdownToHtml } = useMarkdown();
    // fetch data
    const fetchFaq = async () => {
      const response = await api.getFaq();

      faq.value = response.data;
      filteredFaq.value = response.data;
    };

    const filter = () => {
      if (query.value) {
        let filtered = faq.value.filter((f) => {
          let q = query.value.toLowerCase();

          if (f.question.toLowerCase().indexOf(q) > -1) return true;
          if (f.answer.toLowerCase().indexOf(q) > -1) return true;

          return false;
        });

        filteredFaq.value = filtered;
      } else {
        filteredFaq.value = faq.value;
      }
    };

    watch(query, () => {
      clearTimeout(queryTimeOut);
      setTimeout(() => {
        filter();
      }, 300);
    });

    onMounted(() => {
      fetchFaq();
    });

    return {
      query,
      filteredFaq,
      t,
      markdownToHtml,
    };
  },
};
</script>
<style  >
.selected-faq .v-expansion-panel-header {
  font-weight: bold;
}

.faq-answer img {
  max-width: 100%;
}
</style>